import { get } from 'lodash';

export const USER_LOGIN_STATUS = {
  ANY: 'ANY',
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
  PUBLIC: 'PUBLIC',
};

export function isUserLoggedIn(user) {
  if (!user) {
    return false;
  }
  return !!user.customerNum;
}

export function verifyUserLoginStatus(user, requiredUserLoginStatus) { // eslint-disable-line consistent-return
  if (requiredUserLoginStatus === USER_LOGIN_STATUS.ANY) {
    return true;
  }
  const isLoggedIn = isUserLoggedIn(user);
  if (requiredUserLoginStatus === USER_LOGIN_STATUS.LOGGED_IN) {
    return isLoggedIn;
  }
  if (requiredUserLoginStatus === USER_LOGIN_STATUS.LOGGED_OUT ||
      requiredUserLoginStatus === USER_LOGIN_STATUS.PUBLIC
  ) {
    return !isLoggedIn;
  }

  throw new Error(`[verifyUserLoginStatus] Unknown user required state "${requiredUserLoginStatus}"`);
}

export const getCsrfTokenFromState = ({ user }) => get(user, 'customerDetails.csrfToken', '');

export function getUserFromExtras(extras) {
  const { user } = extras.store.getState();

  return user;
}
